export const allProducts = ['xTrend', 'xTable', 'xSignage', 'xMeter', 'xStadium']

export const xTableSections = ['overview', 'statistics', 'games', 'trends', 'view', 'players', 'slots', 'dealers']
